<template>
<div>
    <div class="title" v-show="matchRecordArray.length > 0">{{ $t("dataStatistics.twoYearData") }}</div>
    <!-- <hr v-show="matchRecordArray.length > 0"/> -->
    <statsHeader v-show="matchRecordArray.length > 0" :dataArray = 'matchRecordArray'/>
    <hr v-show="matchRecordArray.length > 0"/>
    <statsTitle v-show="matchRecordArray.length > 0"/>
    <hr v-show="matchRecordArray.length > 0"/>
    <div v-for="(item, index) in matchRecordArray" :key='index'>
        <statsDetailCell :record = 'item'/>
        <hr/>
    </div>
    <loadStateView :state="netState" :refreshHandle="loadData"/>
</div>
</template>

<script>
import statsHeader from '../components/statsHeader'
import statsTitle from '../components/statsTitle'
import statsDetailCell from '../components/statsDetailCell'
export default {
  name: 'stats',
  components: {
    statsHeader,
    statsTitle,
    statsDetailCell
  },
  data () {
    return {
      matchRecordArray: [],
      playerId: this.$route.params.playerId,
      netState: 0
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.netState = 1
      this.$dataBaseClient.get(`f_player/gameData?playerId=${this.$route.params.playerId}`)
        .then((response) => {
          if (response.gameData !== undefined) {
            this.matchRecordArray = response.gameData
          }
          this.netState = this.matchRecordArray.length > 0 ? response.netState : 3
        })
        .catch((error) => {
          this.netState = 2
          console.log(error)
        })
        .then(function () {
          // always executed
        })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "style"
</style>
